import React, { useState } from 'react';
import { useChat } from '../contexts/ChatContext';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from '../components/ui/dialog';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Switch } from '../components/ui/switch';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TeamDialog = ({ open, onClose }) => {
  const { loadTeams } = useChat();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/teams`, { name, description, is_private: isPrivate });
      toast.success('Team created successfully');
      loadTeams();
      setName('');
      setDescription('');
      setIsPrivate(false);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to create team');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="team-dialog">
        <DialogHeader>
          <DialogTitle style={{fontFamily: 'Space Grotesk'}}>Create Team</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleCreate} className="space-y-4">
          <div>
            <Label htmlFor="team-name">Team Name</Label>
            <Input
              id="team-name"
              placeholder="e.g., Engineering, Marketing"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              data-testid="team-name-input"
            />
          </div>
          <div>
            <Label htmlFor="team-desc">Description</Label>
            <Input
              id="team-desc"
              placeholder="What's this team about?"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              data-testid="team-description-input"
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <Label>Private Team</Label>
              <p className="text-xs text-muted-foreground">Only invited members can join</p>
            </div>
            <Switch checked={isPrivate} onCheckedChange={setIsPrivate} data-testid="team-private-toggle" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={loading} data-testid="team-create-submit">
              {loading ? 'Creating...' : 'Create Team'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TeamDialog;
